<template>
  <md-card>
    <md-card-header>
      <h3>Siniestros seleccionados</h3>
    </md-card-header>

    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-20">Siniestros seleccionados: {{ totalItems }}</div>
        <div class="md-layout-item md-size-20">Total (USD): {{ totalMoney | money }}</div>
        <div
          v-if="editMode"
          class="md-layout-item md-size-20"
        >Valor de dolar anterior (USD): {{ previousDollarPrice | money }}</div>
        <div class="md-layout-item md-size-20">
          <md-field>
            <label>Dolar</label>
            <md-input v-model="dollarPrice" type="number"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-20">
          <md-button class="md-primary" @click="submit">Guardar paquete</md-button>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import { money } from "@/filters";
import ExtranetService from "../../services/extranet";

export default {
  name: "SelectedSinistersSummary",
  props: {
    items: { type: Array },
    fetchedRelatedAffected: { type: Array },
    previousDollarPrice: { type: Number },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dollarPrice: 0,
    };
  },
  mounted() {
    ExtranetService.dollar2peso("USD").then((response) => {
      this.dollarPrice = response.rates.MXN.toFixed(6);
    });
  },
  computed: {
    totalItems() {
      return this.items.length;
    },
    totalMoney() {
      if (this.editMode) {
        let total = 0.0;
        this.items.forEach((element) => {
          const quantity = element.total.replace("$", "");
          if (this.fetchedRelatedAffected.some((a) => a.id === element.id)) {
            total += Number(quantity.replace(",", ""));
          } else {
            total += Number(quantity.replace(",", ""));
          }
        });
        return total / this.dollarPrice;
      } else {
        let total = 0.0;
        this.items.forEach((element) => {
          const quantity = element.total.replace("$", "");
          total += Number(quantity.replace(",", ""));
        });
        return total / this.dollarPrice;
      }
    },
  },
  methods: {
    submit() {
      this.$emit("save", this.dollarPrice);
    },
  },
  watch: {
    previousDollarPrice() {
      this.dollarPrice = this.previousDollarPrice;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/extranet/SelectedSinistersSummary.vue